// extracted by mini-css-extract-plugin
export default {"container":"CardLayout_container__bR9Dd"};